import React from "react"
import { motion } from "framer-motion"
import AnimatedTextLogo from "./AnimatedTextLogo"
import { Link } from "react-router-dom"
import { PAGE_URLS } from "../../constants/page-urls"

const LandingPageText = () => {
    return (
        <div className="flex text-center lg:text-start flex-col h-full justify-center p-4 space-y-12 lg:space-y-8">
            <motion.h1
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                className=" text-3xl md:text-4xl font-semibold"
            >
                <span className=" bg-gradient-to-br from-primary-50 to-primary-100 inline-block text-transparent bg-clip-text relative">
                    Välkommen till
                    <span className="absolute top-10 left-0 w-full  text-primary-100">
                        <AnimatedTextLogo />
                    </span>
                </span>{" "}
                <br />{" "}
                <span className="text-7xl lg:text-8xl  opacity-0">Hotspot</span>
            </motion.h1>
            <motion.p
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                className="text-primary-100 text-center lg:text-start text-lg font-semibold max-w-[35ch] mx-auto leading-8 mb-8"
            >
                Knyt värdefulla kontakter på Karlstad Universitets största
                jobbmässa. Missa inte chansen!
            </motion.p>
            <motion.div
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                whileTap={{ scale: 0.9 }}
                whileHover={{ scale: 1.05 }}
            >
                <Link
                    to={PAGE_URLS.SEARCH}
                    className="flex items-center justify-center w-full mx-auto lg:mx-0 bg-gradient-to-br from-white to-primary-100 text-primary-700 font-bold text-lg p-3 md:max-w-sm lg:max-w-xs rounded-lg shadow-xl "
                >
                    Sök Montrar
                </Link>
            </motion.div>
        </div>
    )
}

export default LandingPageText
